var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClubHouseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ClubHouse_White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 176.074,
    height: 176.082,
    viewBox: "0 0 176.074 176.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff8f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M176.086,33.532a7.744,7.744,0,0,0-7.735-7.741H134.47V15.032A7.741,7.741,0,0,0,131.889,0h-87.7a7.741,7.741,0,0,0-2.576,15.037V25.793H7.734A7.741,7.741,0,0,0,5.153,40.824V158.033a2.581,2.581,0,0,0,2.581,2.573H57.087L42.645,171.439a2.581,2.581,0,0,0,1.545,4.643h87.7a2.581,2.581,0,0,0,1.551-4.643L119,160.606H168.35a2.581,2.581,0,0,0,2.573-2.573h0V40.823a7.741,7.741,0,0,0,5.163-7.291Zm-41.61,7.735h31.293v87.7h-31.3ZM44.192,5.158h87.7a2.581,2.581,0,1,1,0,5.158H54.509a2.581,2.581,0,0,0,0,5.158h74.815V155.445h-5.17V100.6a2.581,2.581,0,0,0-2.581-2.59H54.509a2.581,2.581,0,0,0-2.576,2.581v54.885H46.77V12.884A2.581,2.581,0,0,0,44.188,10.3h0a2.581,2.581,0,0,1,0-5.158Zm46.43,150.314V123.8h18.05v31.642Zm-23.215,0V123.8H85.463v31.642Zm43.849-36.8H64.829a2.581,2.581,0,0,0-2.581,2.581h0v34.218H57.09v-52.3H119v52.275h-5.161V121.229a2.581,2.581,0,0,0-2.581-2.581Zm-69.641-77.4v87.7h-31.3v-87.7ZM7.734,30.95h33.88v5.158H7.734a2.581,2.581,0,1,1,0-5.158Zm2.583,103.171h31.3v21.327h-31.3Zm113.831,36.8H51.931l13.757-10.317H110.4Zm10.317-15.474V134.122h31.293v21.327ZM168.35,36.108H134.465V30.95H168.35a2.581,2.581,0,0,1,0,5.158Z",
    transform: "translate(-0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M35,133.417H50.832a2.581,2.581,0,0,0,2.581-2.581V99.871a2.581,2.581,0,0,0-2.581-2.581H35a2.581,2.581,0,0,0-2.576,2.581h0v30.95a2.581,2.581,0,0,0,2.576,2.6Zm2.581-30.95h10.66v25.791H37.589Z",
    transform: "translate(-16.963 -50.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M311,97.29H295.176a2.581,2.581,0,0,0-2.576,2.581h0v30.95a2.581,2.581,0,0,0,2.576,2.6H311a2.581,2.581,0,0,0,2.576-2.581V99.871A2.581,2.581,0,0,0,311,97.29Zm-2.581,30.956h-10.66V102.477h10.66Z",
    transform: "translate(-152.982 -50.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M35,219.888H50.832a2.581,2.581,0,0,0,2.581-2.576V186.356a2.581,2.581,0,0,0-2.581-2.576H35a2.576,2.576,0,0,0-2.576,2.576v30.956A2.576,2.576,0,0,0,35,219.888Zm2.581-30.95h10.66v25.768H37.589Z",
    transform: "translate(-16.963 -96.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M311,183.78H295.176a2.576,2.576,0,0,0-2.576,2.576v30.956a2.576,2.576,0,0,0,2.576,2.576H311a2.576,2.576,0,0,0,2.576-2.576V186.356A2.576,2.576,0,0,0,311,183.78Zm-2.581,30.95h-10.66V188.962h10.66Z",
    transform: "translate(-152.982 -96.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M139.56,74.48H123.736a2.581,2.581,0,0,0-2.576,2.581h0v30.95a2.581,2.581,0,0,0,2.576,2.581H139.56a2.581,2.581,0,0,0,2.576-2.581V77.061A2.581,2.581,0,0,0,139.56,74.48Zm-2.58,30.956H126.335V79.667h10.66Z",
    transform: "translate(-63.351 -38.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M223.861,75.93h-15.8A2.581,2.581,0,0,0,205.48,78.5h0v30.954a2.581,2.581,0,0,0,2.581,2.581h15.8a2.581,2.581,0,0,0,2.576-2.581V78.5A2.576,2.576,0,0,0,223.861,75.93Zm-2.581,30.95H210.639V81.112H221.3Z",
    transform: "translate(-107.435 -39.698)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubHouseWhite);
export default __webpack_public_path__ + "static/media/ClubHouse_White.b4b10359f00bd2a28ebd7fe24cf13758.svg";
export { ForwardRef as ReactComponent };